import { Component, OnInit, Input } from '@angular/core';
import { Location } from "@angular/common";
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.css']
})
export class BackButtonComponent implements OnInit {

  @Input() route:string[];

  constructor(private location: Location, private router:Router
    , private activeRoute:ActivatedRoute) { }

  ngOnInit() {
  }

  goBack() {
    if (this.route && this.route.length) {
      this.router.navigate(this.route, {relativeTo: this.activeRoute});
    }
    else {
      this.location.back();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/back-button/back-button.component.ts